<div class="contact-info">
  <div class="container mx-auto px-4">
    <div
      class="flex flex-wrap items-stretch bg-white overflow-hidden contact-content translate-y-[10%] lg:translate-y-[20%] relative z-10"
    >
      <!-- Contact Info Section -->
      <div class="w-full md:w-6/12 p-3 lg:p-8">
        <div class="w-full lg:w-[422px]">
          <h2 class="form-title mb-2">{{ contactInfo.title }}</h2>
          <p class="description mb-7">{{ contactInfo.description }}</p>

          <!-- Address -->
          <div class="mb-4 flex items-start gap-3">
            <i class="pi pi-map-marker text-[#3D424D] text-xl"></i>
            <div class="">
              <p class="title-txt mb-2">Address</p>
              <p class="address-txt">{{ contactInfo.address }}</p>
            </div>
          </div>

          <!-- Phone -->
          <div class="mb-4 flex items-start gap-3">
            <i class="pi pi-phone text-[#3D424D] text-xl"></i>
            <div class="">
              <p class="title-txt mb-2">Phone</p>
              <p class="address-txt">{{ contactInfo.phone }}</p>
            </div>
          </div>

          <!-- Emails -->
          <div class="mb-4 flex items-start gap-3">
            <i class="pi pi-envelope text-[#3D424D] text-xl"></i>
            <div>
              <p class="title-txt mb-2">Email</p>
              <p *ngFor="let email of contactInfo.emails" class="address-txt">
                <a [href]="email">{{ email }}</a>
              </p>
            </div>
          </div>

          <!-- Social Links -->
          <div class="flex space-x-4">
            <a
              *ngFor="let social of contactInfo.socialLinks"
              [href]="social.link"
              target="_blank"
              [class]="social.class + '-btn btn'"
            >
              <i [class]="social.icon"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- Get A Quote Section -->
      <div class="w-full md:w-6/12 contact-form">
        <h2 class="title py-4">Send us a message ...</h2>
        <p class="description mb-4 lg:w-8/12">
          Fill up the form and our Team will get back to you within 24 hours.
        </p>
        <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
          <div class="mb-4">
            <input
              pInputText
              type="text"
              placeholder="Name"
              class="w-full form-control"
              formControlName="name"
            />
          </div>
          <div class="mb-4">
            <input
              pInputText
              type="email"
              placeholder="Email"
              class="w-full form-control"
              formControlName="email"
            />
          </div>
          <div class="mb-4">
            <input
              pInputText
              type="text"
              placeholder="Subject"
              class="w-full form-control"
              formControlName="subject"
            />
          </div>
          <div class="mb-4">
            <textarea
              pInputTextarea
              placeholder="Your Message"
              class="w-full"
              rows="4"
              formControlName="message"
            ></textarea>
          </div>
          <button
            pButton
            type="submit"
            label="Send Message"
            class="submit-btn"
            [disabled]="contactForm.invalid || isSubmitting"
          ></button>
        </form>
      </div>
    </div>
  </div>
  <!-- Map Section -->
  <div class="mt-8">
    <div class="overly">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d118322.9355505882!2d-77.80241788458896!3d39.06935809941347!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sus!4v1736251837282!5m2!1sen!2sus"
        width="100%"
        height="300"
        style="border: 0"
        allowfullscreen=""
        loading="lazy"
      ></iframe>
    </div>
  </div>
</div>
